/* eslint-disable react/prefer-stateless-function */
/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import BannerExample from '../examples/BannerMobile';
import DocFullScreenExample from '../UI/DocFullScreenExample';
const BannerExampleSource = require('!!raw-loader!../examples/BannerMobile');
export default class BannersPage extends React.Component {
    render() {
        return (<div>
                <Helmet title="Banners"/>
                <h3>Banners</h3>
                <hr />
                <DocFullScreenExample className="pt-11">
                    <BannerExample />
                </DocFullScreenExample>

                <pre>
                    <PrismCode className="language-jsx">{BannerExampleSource}</PrismCode>
                </pre>
            </div>);
    }
}
